
import { mapGetters, mapMutations } from 'vuex';
import store from './../../store';
export default {
  data() {
    return {
     
    };
  },

  props: {
    form: {
      type: Object,
      require: true,
    },

  },

  computed: {
    ...mapGetters({
      prices: 'allProductPrices',
    }),
  },

  watch: { 

   
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Defines the handler for the links one the table.
     *
     * @param  {Object} item The row item.
     * @param  {String} name The field name.
     * @return {Mixed}      False or the handler function in case of a link needed.
     */
    tableClickHandler(item, name) {
      
    },
    
    /**
     * Saves the form, adding a product.
     */
    save() {
        const data = this.form.data();
        const self = this;
        let price  = [];
        if (data.priceField) {
          price = this.prices
          .filter(p => p.priceField.toString() === data.priceField.toString());
        
          if(price.length > 0){
            this.$message({
              showClose: true,
              customClass: 'error',
              message: 'Price field already added',
            });
            return Promise.reject();
          }
        }else{
          this.$message({
            showClose: true,
            customClass: 'error',
            message: 'Price field not found',
          });
          return Promise.reject();
        }
         
        store.dispatch('addProductPrice', data);
        return Promise.all([]);
    },

    /**
     * Updates a Price product.
     */
    update(orderProductId) {
        const data = this.form.data();
        var i = -1;
        for(var index = 0; index < this.prices.length; index++){
            if(data.priceField.toString() === this.prices[index].priceField.toString()){
              i = index;
            }
        }
       
        store.dispatch('updateProductPrice', {data, i});
        return Promise.all([]);
        
    },

    /**
     * Delete the product price.
     */
    destroy(orderProductId,item) {
      console.log(item);
      var i = -1;
        for(var index = 0; index < this.prices.length; index++){
            if(item.priceField.toString() === this.prices[index].priceField.toString()){
              i = index;
            }
        }
      store.dispatch('removeProductPrice',i);
      return Promise.all([]);
    },
  },

  mounted() {
    
  },

  components: {
    VFormTable: require('./../formTable/formTable.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/productPriceTable/productPriceTable.js